
import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS.js';
import Projection from 'ol/proj/Projection';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS.js';

const SOURCE_CLASSES = {
    'TileWMS': {
        layer: TileLayer,
        source: TileWMS
    },
    'ImageWMS': {
        layer: ImageLayer,
        source: ImageWMS
    }
};

function createLayer(layer, view) {
    let layerOptions = {
        id: layer.id,
        maxResolution: getResolutionForZoom(layer.minZoom, view),
        minResolution: getResolutionForZoom(layer.maxZoom, view),
        source: createLayerSource(layer.type, layer.source)
    };
    return new SOURCE_CLASSES[layer.type].layer(layerOptions);
}

export function createLayers(layers, view) {
    return layers.map(item => {
        return createLayer(item, view);
    });
}

function createLayerSource(layerType, sourceOptions) {
    return new SOURCE_CLASSES[layerType].source(sourceOptions);
}

export function createProjection(projectionCode) {
    return new Projection({
        code: projectionCode,
        units: 'm'
    });
}

export function getResolutionForZoom(zoom, view) {
    if (zoom && view) {
        return view.getResolutionForZoom(zoom);
    }
}
